import React from 'react';
import ReactToPrint from "react-to-print";

export default class Page7 extends React.Component {

    render() {

        const {pageData} = this.props;

        return <div id="region-main-pad">
            <div id="region-main"><span id="user-notifications"/>
                <div className="region-content">
                    <div role="main"><span id="maincontent"/>

                        <section>
                            <div className="">

                                <div className="ilead-rgt task">
                                    <div className="innerpadding">

                                        <div className="ilead-contentarea">

                                            <ReactToPrint
                                                trigger={() => <div className={'d-flex justify-content-end'}>
                                                    <div onClick={this.downloadPdf} className="button-print task">Print</div>
                                                </div>}
                                                content={ () => {
                                                    let html = document.body.getElementsByClassName('ilead-tools-pages-content')[0].cloneNode(true);

                                                    let div1 = document.createElement('div');
                                                    div1.className = 'ilead-tools-pages';
                                                    div1.appendChild(html);

                                                    let div2 = document.createElement('div');
                                                    div2.className = 'ilead-tools-body react-print';
                                                    div2.appendChild(div1);

                                                    return div2.cloneNode(true);
                                                }}
                                            />

                                            <br/>
                                            <div className="mobile-scroll">
                                                <table className="ilead_v_sport " border="0" cellPadding="0"
                                                       cellSpacing="0" width="100%">
                                                    <tbody>
                                                    <tr>
                                                        <th className="green_curve " align="left"
                                                            valign="top" width="34%">FLOW FACTORS
                                                        </th>
                                                        <th align="left" valign="top" width="34%">DRIVING
                                                            FORCES
                                                        </th>
                                                        <th className=" green_curve1" align="left"
                                                            valign="top" width="34%">RESTRAINING FORCES
                                                        </th>
                                                    </tr>


                                                    <tr>
                                                        <td className=" darkgreen " align="left"
                                                            valign="top" width="34%">

                                                             <textarea className="TaskTextArea1"
                                                                       name="1"
                                                                       value={this.props.pageData?.FlowFactors?.[1]}
                                                                       onChange={this.props.handleChangePageData('FlowFactors')}/>
                                                        </td>
                                                        <td className=" darkgreen " align="left"
                                                            valign="top" width="34%">

                                                            <textarea className="TaskTextArea1"
                                                                      name="1"
                                                                      value={this.props.pageData?.DrivingForces?.[1]}
                                                                      onChange={this.props.handleChangePageData('DrivingForces')}/>
                                                        </td>
                                                        <td className=" darkgreen " align="left"
                                                            valign="top" width="34%">

                                                            <textarea className="TaskTextArea1"
                                                                      name="1"
                                                                      value={this.props.pageData?.RestrainingForces?.[1]}
                                                                      onChange={this.props.handleChangePageData('RestrainingForces')}/>
                                                        </td>
                                                    </tr>


                                                    <tr>
                                                        <td className=" darkgreen " align="left"
                                                            valign="top" width="34%">

                                                             <textarea className="TaskTextArea1"
                                                                       name="2"
                                                                       value={this.props.pageData?.FlowFactors?.[2]}
                                                                       onChange={this.props.handleChangePageData('FlowFactors')}/>
                                                        </td>
                                                        <td className=" darkgreen " align="left"
                                                            valign="top" width="34%">

                                                            <textarea className="TaskTextArea1"
                                                                      name="2"
                                                                      value={this.props.pageData?.DrivingForces?.[2]}
                                                                      onChange={this.props.handleChangePageData('DrivingForces')}/>
                                                        </td>
                                                        <td className=" darkgreen " align="left"
                                                            valign="top" width="34%">

                                                            <textarea className="TaskTextArea1"
                                                                      name="2"
                                                                      value={this.props.pageData?.RestrainingForces?.[2]}
                                                                      onChange={this.props.handleChangePageData('RestrainingForces')}/>
                                                        </td>
                                                    </tr>


                                                    <tr>
                                                        <td className=" darkgreen " align="left"
                                                            valign="top" width="34%">

                                                             <textarea className="TaskTextArea1"
                                                                       name="3"
                                                                       value={this.props.pageData?.FlowFactors?.[3]}
                                                                       onChange={this.props.handleChangePageData('FlowFactors')}/>
                                                        </td>
                                                        <td className=" darkgreen " align="left"
                                                            valign="top" width="34%">

                                                            <textarea className="TaskTextArea1"
                                                                      name="3"
                                                                      value={this.props.pageData?.DrivingForces?.[3]}
                                                                      onChange={this.props.handleChangePageData('DrivingForces')}/>
                                                        </td>
                                                        <td className=" darkgreen " align="left"
                                                            valign="top" width="34%">

                                                            <textarea className="TaskTextArea1"
                                                                      name="3"
                                                                      value={this.props.pageData?.RestrainingForces?.[3]}
                                                                      onChange={this.props.handleChangePageData('RestrainingForces')}/>
                                                        </td>
                                                    </tr>


                                                    <tr>
                                                        <td className=" darkgreen " align="left"
                                                            valign="top" width="34%">

                                                             <textarea className="TaskTextArea1"
                                                                       name="4"
                                                                       value={this.props.pageData?.FlowFactors?.[4]}
                                                                       onChange={this.props.handleChangePageData('FlowFactors')}/>
                                                        </td>
                                                        <td className=" darkgreen " align="left"
                                                            valign="top" width="34%">

                                                            <textarea className="TaskTextArea1"
                                                                      name="4"
                                                                      value={this.props.pageData?.DrivingForces?.[4]}
                                                                      onChange={this.props.handleChangePageData('DrivingForces')}/>
                                                        </td>
                                                        <td className=" darkgreen " align="left"
                                                            valign="top" width="34%">

                                                            <textarea className="TaskTextArea1"
                                                                      name="4"
                                                                      value={this.props.pageData?.RestrainingForces?.[4]}
                                                                      onChange={this.props.handleChangePageData('RestrainingForces')}/>
                                                        </td>
                                                    </tr>


                                                    <tr>
                                                        <td className=" darkgreen " align="left"
                                                            valign="top" width="34%">

                                                             <textarea className="TaskTextArea1"
                                                                       name="5"
                                                                       value={this.props.pageData?.FlowFactors?.[5]}
                                                                       onChange={this.props.handleChangePageData('FlowFactors')}/>
                                                        </td>
                                                        <td className=" darkgreen " align="left"
                                                            valign="top" width="34%">

                                                            <textarea className="TaskTextArea1"
                                                                      name="5"
                                                                      value={this.props.pageData?.DrivingForces?.[5]}
                                                                      onChange={this.props.handleChangePageData('DrivingForces')}/>
                                                        </td>
                                                        <td className=" darkgreen " align="left"
                                                            valign="top" width="34%">

                                                            <textarea className="TaskTextArea1"
                                                                      name="5"
                                                                      value={this.props.pageData?.RestrainingForces?.[5]}
                                                                      onChange={this.props.handleChangePageData('RestrainingForces')}/>
                                                        </td>
                                                    </tr>


                                                    <tr>
                                                        <td className=" darkgreen " align="left"
                                                            valign="top" width="34%">

                                                             <textarea className="TaskTextArea1"
                                                                       name="6"
                                                                       value={this.props.pageData?.FlowFactors?.[6]}
                                                                       onChange={this.props.handleChangePageData('FlowFactors')}/>
                                                        </td>
                                                        <td className=" darkgreen " align="left"
                                                            valign="top" width="34%">

                                                            <textarea className="TaskTextArea1"
                                                                      name="6"
                                                                      value={this.props.pageData?.DrivingForces?.[6]}
                                                                      onChange={this.props.handleChangePageData('DrivingForces')}/>
                                                        </td>
                                                        <td className=" darkgreen " align="left"
                                                            valign="top" width="34%">

                                                            <textarea className="TaskTextArea1"
                                                                      name="6"
                                                                      value={this.props.pageData?.RestrainingForces?.[6]}
                                                                      onChange={this.props.handleChangePageData('RestrainingForces')}/>
                                                        </td>
                                                    </tr>


                                                    <tr>
                                                        <td className=" darkgreen " align="left"
                                                            valign="top" width="34%">

                                                             <textarea className="TaskTextArea1"
                                                                       name="7"
                                                                       value={this.props.pageData?.FlowFactors?.[7]}
                                                                       onChange={this.props.handleChangePageData('FlowFactors')}/>
                                                        </td>
                                                        <td className=" darkgreen " align="left"
                                                            valign="top" width="34%">

                                                            <textarea className="TaskTextArea1"
                                                                      name="7"
                                                                      value={this.props.pageData?.DrivingForces?.[7]}
                                                                      onChange={this.props.handleChangePageData('DrivingForces')}/>
                                                        </td>
                                                        <td className=" darkgreen " align="left"
                                                            valign="top" width="34%">

                                                            <textarea className="TaskTextArea1"
                                                                      name="7"
                                                                      value={this.props.pageData?.RestrainingForces?.[7]}
                                                                      onChange={this.props.handleChangePageData('RestrainingForces')}/>
                                                        </td>
                                                    </tr>


                                                    <tr>
                                                        <td className=" darkgreen " align="left"
                                                            valign="top" width="34%">

                                                             <textarea className="TaskTextArea1"
                                                                       name="8"
                                                                       value={this.props.pageData?.FlowFactors?.[8]}
                                                                       onChange={this.props.handleChangePageData('FlowFactors')}/>
                                                        </td>
                                                        <td className=" darkgreen " align="left"
                                                            valign="top" width="34%">

                                                            <textarea className="TaskTextArea1"
                                                                      name="8"
                                                                      value={this.props.pageData?.DrivingForces?.[8]}
                                                                      onChange={this.props.handleChangePageData('DrivingForces')}/>
                                                        </td>
                                                        <td className=" darkgreen " align="left"
                                                            valign="top" width="34%">

                                                            <textarea className="TaskTextArea1"
                                                                      name="8"
                                                                      value={this.props.pageData?.RestrainingForces?.[8]}
                                                                      onChange={this.props.handleChangePageData('RestrainingForces')}/>
                                                        </td>
                                                    </tr>


                                                    </tbody>
                                                </table>
                                            </div>

                                            <div className="react-print-none">
                                                <ol className="brownbullet-list listcontentSpacing" start="3">

                                                    <li><p>Once you’ve completed Step 2, think of ways you can
                                                        increase the probability of
                                                        experiencing ‘flow’. Consider the following
                                                        questions:</p></li>

                                                </ol>
                                                <br/>
                                                <table className="ilead_v_sport people_active" border="0"
                                                       cellPadding="0" cellSpacing="0" width="100%">
                                                    <tbody>
                                                    <tr>
                                                        <th className="green_curve green_curve1"
                                                            align="left" valign="top" width="100%">Enhance
                                                            Probability of Flow
                                                        </th>
                                                    </tr>


                                                    <tr>
                                                        <td className=" darkgreen " align="left"
                                                            valign="top" width="50%"><p>1. How will you deal
                                                            with, and/or manage, the restraining forces, so
                                                            that they don’t upset your flow experience?</p>
                                                            <textarea className="TaskTextArea1"
                                                                      name="1"
                                                                      value={this.props.pageData?.EnhanceProbabilityOfFlow?.[1]}
                                                                      onChange={this.props.handleChangePageData('EnhanceProbabilityOfFlow')}/>

                                                        </td>
                                                    </tr>


                                                    <tr>
                                                        <td className="lightgreen " align="left"
                                                            valign="top" width="50%"><p>2. What action steps
                                                            do you need to take to maintain equilibrium?</p>
                                                            <textarea className="TaskTextArea1"
                                                                      name="2"
                                                                      value={this.props.pageData?.EnhanceProbabilityOfFlow?.[2]}
                                                                      onChange={this.props.handleChangePageData('EnhanceProbabilityOfFlow')}/>

                                                        </td>
                                                    </tr>


                                                    </tbody>
                                                </table>


                                                <ol className="brownbullet-list listcontentSpacing"
                                                    start="4">

                                                    <li><p>Once you’ve completed this exercise for yourself,
                                                        you can then share it with the rest of your
                                                        team and/or facilitate a session whereby each team
                                                        member draws their own energy field.</p></li>

                                                </ol>


                                            </div>

                                            <div className="left-btn">
                                                <div
                                                    onClick={this.props.handleChangePage('Page6')}
                                                    className="button-next-previous-done task">&lt;&lt; Previous
                                                </div>
                                            </div>
                                            <div className="right-btn">
                                                <div onClick={this.props.savePageData('Page8')}
                                                     className="button-next-previous-done task">Next &gt;&gt;</div>
                                            </div>


                                        </div>

                                    </div>


                                </div>


                            </div>
                        </section>


                    </div>
                </div>
            </div>
        </div>;
    }
}